import React, { useState } from "react";
import { Questionnaire, QuestionnaireDefinition } from "../common/models";
import { QuestionnaireTaskView } from "../common/QuestionnaireTaskView";


const Definition: QuestionnaireDefinition = {
  name: 'VHI-10',
  key: 'vhiQuestionnaire',
  title: 'Voice Handicap Index (VHI-10)',
  description: '',
  cohort: 'generic',
  type: 'questionnaire',
  estimatedCompletionTime: '1:05',
  groups: [
    {
      key: 'vhi10',
      questions: [
        {
          // The key is REDCap model.
          key: 'voiceDifficultHear',
          type: 'multiple-choice',
          question: 'My voice makes it difficult for people to hear me.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost Never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost Always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is REDCap model.
          key: 'toughToUnderstand',
          type: 'multiple-choice',
          question: 'People have difficulty understanding me in a noisy room.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost Never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost Always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is REDCap model.
          key: 'voiceRestrictSocial',
          type: 'multiple-choice',
          question: 'My voice difficulties restrict personal and social life.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost Never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost Always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is REDCap model.
          key: 'leftOutConversations',
          type: 'multiple-choice',
          question: 'I feel left out of conversations because of my voice.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost Never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost Always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is REDCap model.
          key: 'voiceLoseIncome',
          type: 'multiple-choice',
          question: 'My voice problem causes me to lose income.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost Never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost Always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },

        {
          // The key is REDCap model.
          key: 'strainVoice',
          type: 'multiple-choice',
          question: 'I feel as though I have to strain to produce voice.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost Never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost Always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          /// The key is REDCap model.
          key: 'voiceClarity',
          type: 'multiple-choice',
          question: 'The clarity of my voice is unpredictable.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost Never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost Always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is REDCap model.
          key: 'voiceUpsetting',
          type: 'multiple-choice',
          question: 'My voice problem upsets me.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost Never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost Always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is REDCap model.
          key: 'voiceHandicapped',
          type: 'multiple-choice',
          question: 'My voice makes me feel handicapped.',
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost Never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost Always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        },
        {
          // The key is REDCap model.
          key: 'askWhatsWrongVoice',
          type: 'multiple-choice',
          question: `People ask, "What's wrong with your voice?"`,
          options: [
            { key: 'never', displayName: 'Never' },
            { key: 'almostNever', displayName: 'Almost Never' },
            { key: 'sometimes', displayName: 'Sometimes' },
            { key: 'almostAlways', displayName: 'Almost Always' },
            { key: 'always', displayName: 'Always' }
          ],
          value:  '',
          defaultValue: '',
          required: true
        }
      ]
    }
  ]
};

export const VHI10Definition = Definition;

export const VHI10 = ({onCompletion}: {onCompletion: () => void}) => {
  const [questionnaire, setQuestionnaire] = useState<Questionnaire>(() => ({
    id: 'vhiQuestionnaires',
    ...Definition,
    startedAt: new Date().toISOString(),
    completedAt: null,
    status: 'in-progress',
  }));

  console.log('VHI10 component rendered', questionnaire);

  const handleOnCompletion = () => {
    console.log('VHI10 completed');

    onCompletion();
  };

  const handleOnChange = (questionnaire: Questionnaire) => {
    console.log('questionnaire', questionnaire);
    setQuestionnaire(questionnaire);
  }

  console.log('VHI10 component rendered', questionnaire);

  return (
    <div>
      <QuestionnaireTaskView questionnaire={questionnaire} onChange={handleOnChange} onCompletion={handleOnCompletion  } />
    </div>
  );
}
